"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckLtlReefer = function SvgIconTruckLtlReefer(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck ltl reefer icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Ltl Reefer Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.223 22.346h-15.24v-3.338S26 19 26 17.5V16c0-1-.017-2.256 0-1l-.017-1.256V7.068a1.87 1.87 0 00-1.88-1.861 1.871 1.871 0 00-1.881 1.861v6.676l-4.31-4.269a1.894 1.894 0 00-2.661 0 1.85 1.85 0 000 2.633l6.971 6.9v3.338h-3.176l-6.971-6.9a1.892 1.892 0 00-2.66 0 1.846 1.846 0 000 2.631l4.313 4.268H6.984a1.87 1.87 0 00-1.88 1.862 1.87 1.87 0 001.88 1.861h6.744l-4.312 4.269a1.846 1.846 0 000 2.632 1.892 1.892 0 002.659 0l6.97-6.9h3.177v3.337l-6.971 6.9a1.85 1.85 0 000 2.633 1.894 1.894 0 002.66 0l4.311-4.269v6.675c0 1.028.842 1.862 1.88 1.862a1.87 1.87 0 001.881-1.861V34.67l4.312 4.269a1.894 1.894 0 002.661 0 1.85 1.85 0 000-2.633l-6.973-6.9V26.07h3.178l6.971 6.9a1.892 1.892 0 002.66 0 1.846 1.846 0 000-2.632l-4.313-4.268h6.744a1.87 1.87 0 001.88-1.862 1.87 1.87 0 00-1.88-1.861zM29 7a1 1 0 00-1 1v11a1 1 0 001 1h11a1 1 0 001-1V8a1 1 0 00-1-1H29zm4.748 2.24h-2.1V18h5.916v-2.004h-3.816V9.24z"
  }));
};

var _default = SvgIconTruckLtlReefer;
exports.default = _default;